import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Title } from 'components/Title';

export default function EnachauthPage() {
		const location = useLocation();
	const [pageReady, setPageReady] = useState(true);
	    const searchParam = new URLSearchParams(window.location.search);
    const loanaccountno = searchParam.get("loanaccountno"); // e.g., ?mid=5
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [reqJson, setReqJson] = useState(null);
    // --- Load jQuery & checkout.js in order ---
    useEffect(() => {
        const jqueryScript = document.createElement("script");
        jqueryScript.src =
        "https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js";
        jqueryScript.type = "text/javascript";
        jqueryScript.onload = () => {
            const checkoutScript = document.createElement("script");
            checkoutScript.src =
            "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js";
            checkoutScript.type = "text/javascript";
            checkoutScript.onload = () => setScriptLoaded(true);
            document.body.appendChild(checkoutScript);
        };
        document.body.appendChild(jqueryScript);
        return () => {
            document.body.removeChild(jqueryScript);
            const checkout = document.querySelector(
            'script[src*="checkout.js"]'
            );
            if (checkout) document.body.removeChild(checkout);
        };
    }, []);
    // --- Fetch the full reqJson from backend ---
    useEffect(() => {
        if (!loanaccountno) return;
        fetch(`${process.env.REACT_APP_API_PATH}kyc/enachdata?loanaccountno=${loanaccountno}`)
        .then((res) => {
            if (!res.ok) throw new Error(`HTTP error! ${res.status}`);
            return res.json();
        })
        .then((data) => {
            // Attach the response handler function dynamically
            data.consumerData.responseHandler = handleResponse;
            setReqJson(data);
        })
        .catch((err) => console.error("❌ API error:", err));
    }, [loanaccountno]);
    // --- Worldline Response Handler ---
    const handleResponse = (res) => {
        if (res?.paymentMethod?.paymentTransaction?.statusCode === "0300") {
            console.log("✅ Payment Success:", res);
            // Send to your backend for processing
            fetch("/api/payment/handle-response", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(res),
            })
            .then((r) => r.json())
            .then((data) => console.log("Server Response:", data))
            .catch((err) => console.error("Error sending response:", err));
            } else {
            console.warn("⚠️ Payment Failed/Invalid:", res);
        }
    };
    // --- Start Payment ---
    const startPayment = () => {
        if (!scriptLoaded || !window.$ || !window.$.pnCheckout) {
            alert("Worldline scripts not loaded yet");
            return;
        }
        if (!reqJson) {
            alert("Consumer data not loaded yet");
            return;
        }
        console.log("🚀 Final Request to Worldline:", reqJson);
        window.$.pnCheckout(reqJson);
        // Open in new window if enabled
        if (reqJson.features.enableNewWindowFlow && window.pnCheckoutShared) {
            window.pnCheckoutShared.openNewWindow();
        }
    };
	return (
		<main id="EnachauthPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="EnachAuth"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div>
                        <h2>eNACH Authorization</h2>
                        <button
                        onClick={startPayment}
                        disabled={!scriptLoaded}
                        style={{
                        background: "#45beaa",
                        color: "#fff",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        }}
                        >
                        Start eNACH Payment
                        </button>
                    </div>
                </div>
                <div className="">
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
